<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createRegisterBook') }}</h1>
      <div class="form-container">
        <RegisterBookForm @save="save"></RegisterBookForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import RegisterBookForm from "@/components/RegisterBookForm"

  export default {
    components: {
      RegisterBookForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/create', {actionType: 'register_books', payload}).then(() =>
          this.$router.push({ name: 'registerBooks'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'register_books'})
    },
    computed: {
      breadcrumbs() {
        return [
          {name: 'registerBooks', path: 'registerBooks'},
          {name: 'createRegisterBook'}
        ]
      }
    }
  }
</script>